module.exports = __webpack_public_path__ + "img/sucess@2x.2ee061a6.png";